export default __webpack_public_path__ + "static/media/logo_yoshinani.f3f97739.svg";